import { getCommonWidget } from '../dashWidgetHelper'
import { commonWidgets, haTrendDataMapper, haWordCountWithLinksMapper  } from './commonWidgetsHa'

const allWidgets = [
  {
    title: 'NPS',
    type: 'label',
    position: [0, 0],
    size: [1, 1],
    config: { color: '#B7AADC' },
  },
  {
    title: 'Unidad de Referencia',
    type: 'label',
    position: [1, 0],
    size: [3, 1],
    config: { color: '#B7AADC' },
  },
  getCommonWidget({
    commonWidgets: commonWidgets,
    name: 'haTrendByGeo',
    title: 'NPS',
    position: [0, 1],
    size: [1, 2],
    mapper: haTrendDataMapper,
    indicator: 'hemodialisis_ambulatoria_usuario_pregunta_14',
    criticalMomentInclude: [11653],
    extraConfigs:{
        valueSymbol:''
     }
  }),
  getCommonWidget({
    commonWidgets: commonWidgets,
    name: 'pieGenericSmall',
    title: 'Unidad de referecnia ',
    position: [1, 1],
    size: [3, 2],
    extraConfigs: {
      showSample: true,
    },
    indicator: 'hemodialisis_ambulatoria_usuario_pregunta_1',
    criticalMomentInclude: [11653]
  }),
  getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'pieGenericSmall',
      title: 'Unidad que proporciona atención',
      position: [0, 3],
      size: [3, 2],
      extraConfigs: {
        showSample: true,
      },
      indicator: 'hemodialisis_ambulatoria_usuario_pregunta_3',
      criticalMomentInclude: [11653]
    }),
  {
    title: 'Evaluación General',
    type: 'label',
    position: [0, 5],
    size: [4, 1],
    config: { color: '#B7AADC' },
  },
  getCommonWidget({
    commonWidgets: commonWidgets,
    name: 'haTrendByGeo',
    title: 'Satisfacción General con el servicio',
    position: [0, 6],
    size: [1, 2],
    mapper: haTrendDataMapper,
    indicator: 'hemodialisis_ambulatoria_usuario_pregunta_6',
    criticalMomentInclude: [11653],
    extraConfigs:{
        valueSymbol:''
    }
  }),
  getCommonWidget({
    commonWidgets: commonWidgets,
    name: 'haTrendByGeo',
    title: 'El trato recibido por el personal de recepción',
    position: [1, 6],
    size: [1, 2],
    mapper: haTrendDataMapper,
    indicator: 'hemodialisis_ambulatoria_usuario_pregunta_7',
    criticalMomentInclude: [11653],
    extraConfigs:{
        valueSymbol:''
    }
  }),
  getCommonWidget({
    commonWidgets: commonWidgets,
    name: 'haTrendByGeo',
    title: 'Claridad de la información sobre la documentación para su atención',
    position: [2, 6],
    size: [1, 2],
    mapper: haTrendDataMapper,
    indicator: 'hemodialisis_ambulatoria_usuario_pregunta_8',
    criticalMomentInclude: [11653],
    extraConfigs:{
        valueSymbol:''
    }
  }),
  getCommonWidget({
    commonWidgets: commonWidgets,
    name: 'haTrendByGeo',
    title: 'Servicio y habilidades del personal de enfermería',
    position: [3, 6],
    size: [1, 2],
    mapper: haTrendDataMapper,
    indicator: 'hemodialisis_ambulatoria_usuario_pregunta_9',
    criticalMomentInclude: [11653],
    extraConfigs:{
        valueSymbol:''
    }
  }),
 {
    title: 'Evaluación General',
    type: 'label',
    position: [0, 8],
    size: [4, 1],
   },
  getCommonWidget({
    commonWidgets: commonWidgets,
    name: 'haTrendByGeo',
    title: 'El trato del personal médico durante su atención',
    position: [0, 9],
    size: [1, 2],
    mapper: haTrendDataMapper,
    indicator: 'hemodialisis_ambulatoria_usuario_pregunta_10',
    criticalMomentInclude: [11653],
    extraConfigs:{
        valueSymbol:''
    }
  }),
  getCommonWidget({
    commonWidgets: commonWidgets,
    name: 'haTrendByGeo',
    title: 'Claridad de la información proporcionada sobre su tratamiento por el médico o la enfermera',
    position: [1, 9],
    size: [1, 2],
    mapper: haTrendDataMapper,
    indicator: 'hemodialisis_ambulatoria_usuario_pregunta_11',
    criticalMomentInclude: [11653],
    extraConfigs:{
        valueSymbol:''
    }
  }),
  getCommonWidget({
     commonWidgets: commonWidgets,
     name: 'haTrendByGeo',
     title: 'Condiciones físicas y limpieza de las instalaciones',
     position: [2, 9],
     size: [1, 2],
     mapper: haTrendDataMapper,
     indicator: 'hemodialisis_ambulatoria_usuario_pregunta_12',
     criticalMomentInclude: [11653],
     extraConfigs:{
         valueSymbol:''
     }
   }),
  getCommonWidget({
     commonWidgets: commonWidgets,
     name: 'textAnalysis',
     position:[0,11], 
     size: [2, 3],
     indicator: 'SENTIMENT',
     criticalMomentInclude: [11653],
     extraConfigs:{
        hideBars: true
     }
   }),
  getCommonWidget({
     commonWidgets: commonWidgets,
     name: 'wordCountWithLinks',
     title: 'Nube de Palabras / Frecuencia en comentarios',
     position: [2, 11],
     size: [2, 3],
     mapper: haWordCountWithLinksMapper,
     criticalMomentInclude: [11653]
   }),
   
]

export default {
  title: 'Hospital Angeles Servicio de Hemodiálisis Ambulatoria',
  description: 'Hospital Angeles Servicio de Hemodiálisis Ambulatoria',
  widgets: (filters: FiltersUI) => {
    return allWidgets
  },
} as DasboardConfig
